import { Loading } from "@/components/common/Loading";
import { Protected } from "@/components/layout/Protected";
import { productoService } from "@/service/services/Producto.service";
import { KEY_EMPRESA, KEY_USER_DATA } from "@/toolbox/constants/local-storage";
import { readLocalStorage } from "@/toolbox/helpers/local-storage-helper";
import { Button, Grid, IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ModalProducto } from "./ModalProducto";
import { DeletedProduct } from "../Editor/components/DeletedProduct";
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import { useHistory } from 'react-router-dom';
import ReceiptIcon from '@mui/icons-material/Receipt';

export const MisProductos: FC = () => {

    const dataUsuario = readLocalStorage(KEY_USER_DATA)
    const dataEmpresa = readLocalStorage(KEY_EMPRESA);
    const history = useHistory()

    const [productos, setProductos] = useState<any[]>([])
    const [productosBackUp, setProductosBackUp] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [showModalProduct, setShowModalProduct] = useState<boolean>(false)
    const [action, setAction] = useState<string>('')
    const [rowSelected, setRowSelected] = useState<any>(null)
    const [showModalDelete, setShowModalDelete] = useState<boolean>(false)

    useEffect(() => {
        getProductosApi()
        console.log('dataEmpresa', dataEmpresa)
    }, [])

    const getProductosApi = async () => {
        setLoading(true)
        const response = await productoService.getProductsByCompany(dataUsuario.user.id_empresa)
        setProductos(response.productos || [])
        setProductosBackUp(response.productos || [])
        setLoading(false)
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const onSearch = (search: string) => {
        if (search !== '') {
            const filteredProducts = productos.filter(product => {
                const searchLowerCase = search.trim().toLowerCase()
                return product.nombre && product.nombre.toLowerCase().startsWith(searchLowerCase)
            })
            setProductos(filteredProducts || [])
        } else {
            setProductos(productosBackUp || [])
        }
    }

    const onDelete = (rowSelected) => {
        setRowSelected(rowSelected)
        setShowModalDelete(true)
    }

    const onShowCodigoBarras = (rowSelected) => {
        history.replace('/codigo-barras/' + rowSelected.id)
    }

    const onShowReceta = (rowSelected) => {
        history.replace('/receta/' + rowSelected.id)
    }

    return (<Protected>
        {loading && <Loading />}
        <Grid container spacing={2}>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Typography variant="h4">MIS PRODUCTOS</Typography>
            </Grid>
            <Grid item container xs={12}
                sx={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    marginBottom: "10px",
                }}
            >
                <Grid item>
                    <TextField
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon fontSize="small" />
                                </InputAdornment>
                            ),
                        }}
                        placeholder="Buscar..."
                        size="small"
                        onChange={(e) => onSearch(e.target.value)}
                    />
                </Grid>
                <Grid
                    item
                    sx={{ textAlign: "right" }}
                >
                    <Button
                        onClick={() => { setAction('create'); setRowSelected(null); setShowModalProduct(true) }}
                        sx={{
                            border: "solid 1px #73B2FF",
                            mt: "10px",
                            color: "#73B2FF",
                            "&:hover": {
                                bgcolor: "#73B2FF",
                                color: "#fff",
                            },
                        }}
                    >
                        Nuevo producto
                    </Button>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>{`N°`}</TableCell>
                                <TableCell align="left">Codigo</TableCell>
                                <TableCell align="left">Nombre</TableCell>
                                <TableCell align="left">Precio standar</TableCell>
                                <TableCell align="left">Precio oferta</TableCell>
                                <TableCell align="left">Tipo de producto</TableCell>
                                <TableCell align="left">Familia</TableCell>
                                <TableCell align="left">Subfamilia</TableCell>
                                <TableCell align="left">Linea</TableCell>
                                <TableCell align="left">Tipo de impuesto</TableCell>
                                <TableCell align="center">Opciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {productos?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((producto, index) =>
                                <TableRow key={index}>
                                    <TableCell align="left">{index + 1 + page * rowsPerPage}</TableCell>
                                    <TableCell align="left">{producto.codigo_erp}</TableCell>
                                    <TableCell align="left">{producto.nombre}</TableCell>
                                    <TableCell align="left">{producto.precio_standar}</TableCell>
                                    <TableCell align="left">{producto.precio_oferta || 0}</TableCell>
                                    <TableCell align="left">{producto.tipo_producto}</TableCell>
                                    <TableCell align="left">{producto.familia || '-'}</TableCell>
                                    <TableCell align="left">{producto.subfamilia || '-'}</TableCell>
                                    <TableCell align="left">{producto.linea || '-'}</TableCell>
                                    <TableCell align="left">{producto.tipo_impuesto}</TableCell>
                                    <TableCell align="center">
                                        <Tooltip title={"Editar producto"}>
                                            <IconButton onClick={() => { setAction('edit'); setRowSelected(producto); setShowModalProduct(true) }}>
                                                <EditIcon color="primary" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title={"Eliminar producto"}>
                                            <IconButton onClick={() => onDelete(producto)}>
                                                <DeleteIcon color="error" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title={"Ver codigos de barras"}>
                                            <IconButton onClick={() => onShowCodigoBarras(producto)}>
                                                <ViewColumnIcon />
                                            </IconButton>
                                        </Tooltip>
                                        {
                                            dataEmpresa?.id_tipo_empresa !== 1 && (
                                                <Tooltip title={"Ver receta"}>
                                                    <IconButton onClick={() => onShowReceta(producto)}>
                                                        <ReceiptIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            )
                                        }
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[20, 30, 40]}
                    component="div"
                    count={productos?.length || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Grid>
        </Grid>
        {
            showModalProduct &&
            <ModalProducto
                open={showModalProduct}
                setOpenPopup={setShowModalProduct}
                action={action}
                rowSelected={rowSelected}
                onList={getProductosApi}
            />
        }
        {
            showModalDelete &&
            <DeletedProduct
                open={showModalDelete}
                closeModal={() => setShowModalDelete(false)}
                ProductId={rowSelected.id}
                TipoProductId={1} //productos simples
                isSupply={0} //no es insumo
                getProductos={getProductosApi}
                text={'¿Está seguro de eliminar el producto?'}
            />
        }
    </Protected>)
}